import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { appContext } from "../../context/ContextProvider";
import { baseUrl } from "../../utils/Constants";
import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

function Login(props) {

    const { user, setUser, setToken, setPermissions } = useContext(appContext);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const storeSessionInStorage = (user, permissions) => {
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('permissions', JSON.stringify(permissions));
    }

    const onSubmitForm = (e) => {
        e.preventDefault();

        var formdata = new FormData();
        formdata.append("email", email);
        formdata.append("password", password);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            redirect: 'follow'
        };

        fetch(`${baseUrl}/login`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status) {
                    setToken(result.token);
                    storeSessionInStorage(result.user, result.permissions);
                    setPermissions(result.permissions);
                    setUser(result.user);
                } else {
                    toast.error("Cannot Login!");
                    console.log('message : ', result.message);
                }
            })
            .catch(error => console.log('error', error));

    }

    return (
        <div class="login-wrap">
            <div class="login-content">
                <div class="login-logo">
                    <a href="#">
                        <img src="images/icon/logo.png" alt="CoolAdmin" />
                    </a>
                </div>
                <div class="login-form">
                    <form onSubmit={(e) => onSubmitForm(e)}>
                        <div class="form-group">
                            <label>Email Address</label>
                            <input class="au-input au-input--full" type="email" name="email" value={email} placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
                        </div>
                        <div class="form-group">
                            <label>Password</label>
                            <input class="au-input au-input--full" type="password" name="password" value={password} placeholder="Password" onChange={(e) => setPassword(e.target.value)} />
                        </div>
                        {/* <div class="login-checkbox">
                            <label>
                                <Link to={'/forgot-password'}>Forgotten Password?</Link>
                            </label>
                        </div> */}
                        <button class="au-btn au-btn--block au-btn--green m-b-20">sign in</button>
                    </form>
                    {/* <div class="register-link">
                        <p>
                            Don't you have account?
                            <Link to={'/register'}>Sign Up Here</Link>
                        </p>
                    </div> */}
                </div>
            </div>
            <ToastContainer />
        </div>
    );
}

export default Login;